import { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { SiteShell } from './shop/layout/SiteShell';
import { ADMIN_BASE, ADMIN_TITLE } from './utils/hosts';
import { PageErrorBoundary } from './ui/PageErrorBoundary';
import { DocumentHead } from './ui/DocumentHead';
import { lazyWithRetry } from './ui/lazyWithRetry';

// Het beheer is een apart ingeladen deel: bezoekers van de webshop downloaden het niet.
// Het draait op hetzelfde domein onder /be (utils/hosts.ts).
const AdminApp = lazyWithRetry(() => import('./admin/AdminApp').then(m => m.AdminApp), 'admin');

/**
 * Drie vangnetten (zie ui/PageErrorBoundary.tsx):
 * - rond alles: een fout in header, footer of een lade (buiten de pagina-foutgrens). Biedt als
 *   laatste uitweg "Lokale gegevens herstellen";
 * - rond het beheer: ook als het beheer-deel niet laadt;
 * - per pagina, in shop/layout/AnimatedRoutes, shop/account/Account en admin/ui/AdminLayout.
 *
 * Het beheer zet noindex al hier, vóór het beheer-deel laadt: ook als dat mislukt, staat de tag.
 */
export function App() {
  return <PageErrorBoundary fullScreen offerReset data-id="element-5534" data-mp="3mlavl1vse5rc">
      <BrowserRouter data-id="element-5535" data-mp="3mjzsz5e2v41t">
        <Routes data-id="element-5536" data-mp="3mjg8bgx1m1k3">
          <Route path={`${ADMIN_BASE}/*`} element={<>
                <DocumentHead title={ADMIN_TITLE} robots="noindex, nofollow" data-id="element-5538" data-mp="5yjetptzbev" />
                <PageErrorBoundary fullScreen offerReset showDetails title="Het beheer laadt even niet." homeHref={ADMIN_BASE} homeLabel="Naar het overzicht" data-id="element-5539" data-mp="82kz509bybz">
                  <Suspense fallback={<div role="status" className="flex min-h-screen min-h-dvh w-full items-center justify-center bg-sand text-[14px] text-muted" data-id="element-5541" data-mp="38lrpeemjd4ho">
                        Beheer laden…
                      </div>} data-id="element-5540" data-mp="33nq6put0v76q">
                    <AdminApp data-id="element-5542" data-mp="nv0zhx4tgw79" />
                  </Suspense>
                </PageErrorBoundary>
              </>} data-id="element-5537" data-mp="3rc9e8848zfxr" />
          <Route path="*" element={<SiteShell data-id="element-5544" data-mp="35ypsmahfq2i" />} data-id="element-5543" data-mp="swglpsiqd8r8" />
        </Routes>
      </BrowserRouter>
    </PageErrorBoundary>;
}